/**
 * Money cell.
 *
 * WHY a component: it is the single place a minor-unit string turns into text, and it also
 * carries the negative/positive colouring that makes a fee column readable at a glance. Values
 * stay strings throughout — see money.ts for why that matters.
 */
import type { ReactNode } from "react";
import type { Minor } from "../api";
import { formatMoney, formatSignedMoney, minorSign } from "../money";

export function Amount({ minor, currency, signed = false, strong = false }: {
  minor: Minor | null | undefined;
  currency: string | null | undefined;
  signed?: boolean;
  strong?: boolean;
}): ReactNode {
  const sign = minorSign(minor);
  const tone = sign < 0 ? "neg" : sign > 0 ? "pos" : "zero";
  const text = signed ? formatSignedMoney(minor, currency) : formatMoney(minor, currency);
  return <span className={`amount amount-${tone}${strong ? " amount-strong" : ""}`}>{text}</span>;
}
